import { IFixedPhraseRegistry, IFixedPhraseRepository } from "../../../domain/document";
import { FixedPhraseRepository } from ".";

export class FixedPhraseRegistry implements IFixedPhraseRegistry {
  constructor(private _getToken: () => string) {
  }

  getFixedPhraseRepository(): IFixedPhraseRepository {
    return new FixedPhraseRepository(this._getToken);
  }
}
